module.exports = __webpack_public_path__ + "static/media/westernplains.f3d9864e.png";